// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-filters-desktop[data-v-7303d588]{display:none;position:sticky;top:1rem}@media screen and (min-width:1264px){.tlm-filters-desktop[data-v-7303d588]{display:block}}.custom-scrollbar[data-v-7303d588]{padding-right:4px}.custom-scrollbar[data-v-7303d588]::-webkit-scrollbar-track{margin:10px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
